import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import { buildMixpanelBoardUrl } from "@/v2-backoffice-client/analytics/analytics.utils"
import {
  FENERUM_ACCOUNT_BASE_URL,
  HUBSPOT_BASE_URL,
} from "@/v2-backoffice-client/constants"

export type TenantExternalToolMenuItemsProps = {
  tenantId: number | null | undefined
  externalCustomerId: string | null | undefined
  /** The owning customer's linked Fenerum account (Tenant.BillingAccountUuid). */
  billingAccountUuid: string | null | undefined
}

// The "Open in …" trio every team action menu offers: HubSpot (the linked
// CRM company), Fenerum (the owning customer's billing account) and
// Mixpanel (a board of the team's users). One component so the four menus
// that show a team — the team list, the team panel, and the team rows
// nested under a customer and under a user — stay in step, and so the next
// external tool lands in all of them at once. Each item disables when the
// team lacks the handle it needs.
function TenantExternalToolMenuItems(props: TenantExternalToolMenuItemsProps) {
  const { tenantId, externalCustomerId, billingAccountUuid } = props

  const hubspotUrl = externalCustomerId
    ? `${HUBSPOT_BASE_URL}/${externalCustomerId}`
    : undefined
  const fenerumUrl = billingAccountUuid
    ? `${FENERUM_ACCOUNT_BASE_URL}/${billingAccountUuid}/`
    : undefined
  const mixpanelUrl =
    tenantId == null
      ? undefined
      : buildMixpanelBoardUrl({
          resourceType: "user",
          propertyName: "User.ActiveTenantId",
          propertyType: "number",
          filterOperator: "equals",
          filterValue: String(tenantId),
        })

  return (
    <>
      <ActionMenu.LinkItem
        iconSrc="hubspot"
        disabled={!hubspotUrl}
        to={hubspotUrl ?? ""}
        external
      >
        Open in HubSpot
      </ActionMenu.LinkItem>

      <ActionMenu.LinkItem
        iconSrc="bank"
        disabled={!fenerumUrl}
        to={fenerumUrl ?? ""}
        external
      >
        Open in Fenerum
      </ActionMenu.LinkItem>

      <ActionMenu.LinkItem
        iconSrc="mixpanel"
        disabled={!mixpanelUrl}
        to={mixpanelUrl ?? ""}
        external
      >
        Open in Mixpanel
      </ActionMenu.LinkItem>
    </>
  )
}

export default TenantExternalToolMenuItems
